import React from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { TabNavigation } from '../../components/operations/TabNavigation';
import { Plus, Calendar, Clock, MapPin } from 'lucide-react';
const MENU_TABS = [{
  label: 'Products',
  path: ''
}, {
  label: 'Categories',
  path: 'categories'
}, {
  label: 'Modifiers',
  path: 'modifiers'
}, {
  label: 'Combos',
  path: 'combos'
}, {
  label: 'Stock',
  path: 'stock'
}, {
  label: 'Promotions',
  path: 'promotions'
}, {
  label: 'Performance',
  path: 'performance'
}];
const ACTIVE_PROMOS = [{
  name: '🎄 Christmas Special — 20% off all Combos',
  discount: '20% off',
  appliesTo: 'All Combos',
  period: 'Dec 15 - Dec 26',
  locations: 'All',
  usage: '127 orders',
  impact: '-89K RSD'
}, {
  name: '🌙 Late Night Deal — Free drink with any burger after 21:00',
  discount: 'Free Pepsi 0.33',
  appliesTo: 'Burgeri category',
  period: 'Ongoing',
  time: '21:00 - 23:00 only',
  locations: 'Vračar, BB',
  usage: '34 orders this week',
  impact: '-5.1K RSD'
}];
export function Promotions() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-1544">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-1545">
        <h1 className="text-2xl font-bold text-text-primary" data-id="element-1546">Promotions</h1>
        <Button icon={<Plus size={16} data-id="element-1548" />} data-id="element-1547">Add Promotion</Button>
      </div>

      <TabNavigation tabs={MENU_TABS} basePath="/menu" data-id="element-1549" />

      <div className="space-y-8" data-id="element-1550">
        <div data-id="element-1551">
          <h3 className="font-bold text-accent-success mb-4 flex items-center gap-2" data-id="element-1552">
            <span className="w-2 h-2 rounded-full bg-accent-success animate-pulse" data-id="element-1553"></span>{' '}
            ACTIVE NOW ({ACTIVE_PROMOS.length})
          </h3>
          <div className="space-y-4" data-id="element-1554">
            {ACTIVE_PROMOS.map((promo, i) => <Card key={i} className="p-6" data-id="element-1555">
                <div className="flex justify-between items-start mb-4" data-id="element-1556">
                  <h3 className="font-bold text-lg" data-id="element-1557">{promo.name}</h3>
                  <div className="flex gap-2" data-id="element-1558">
                    <Button size="sm" variant="secondary" data-id="element-1559">
                      Edit
                    </Button>
                    <Button size="sm" variant="secondary" className="text-accent-error hover:text-accent-error hover:bg-accent-error/10" data-id="element-1560">
                      End Early
                    </Button>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-1561">
                  <div className="space-y-2 text-sm" data-id="element-1562">
                    <div className="flex justify-between" data-id="element-1563">
                      <span className="text-text-secondary" data-id="element-1564">Discount:</span>
                      <span className="font-bold" data-id="element-1565">{promo.discount}</span>
                    </div>
                    <div className="flex justify-between" data-id="element-1566">
                      <span className="text-text-secondary" data-id="element-1567">Applies to:</span>
                      <span data-id="element-1568">{promo.appliesTo}</span>
                    </div>
                    <div className="flex justify-between" data-id="element-1569">
                      <span className="text-text-secondary" data-id="element-1570">Period:</span>
                      <span className="flex items-center gap-1" data-id="element-1571">
                        <Calendar size={14} data-id="element-1572" /> {promo.period}
                      </span>
                    </div>
                    {promo.time && <div className="flex justify-between" data-id="element-1573">
                        <span className="text-text-secondary" data-id="element-1574">Time:</span>
                        <span className="flex items-center gap-1" data-id="element-1575">
                          <Clock size={14} data-id="element-1576" /> {promo.time}
                        </span>
                      </div>}
                    <div className="flex justify-between" data-id="element-1577">
                      <span className="text-text-secondary" data-id="element-1578">Locations:</span>
                      <span className="flex items-center gap-1" data-id="element-1579">
                        <MapPin size={14} data-id="element-1580" /> {promo.locations}
                      </span>
                    </div>
                  </div>

                  <div className="bg-background-elevated/30 rounded-lg p-4 space-y-2 text-sm" data-id="element-1581">
                    <div className="flex justify-between" data-id="element-1582">
                      <span className="text-text-secondary" data-id="element-1583">Usage:</span>
                      <span className="font-bold" data-id="element-1584">{promo.usage}</span>
                    </div>
                    <div className="flex justify-between" data-id="element-1585">
                      <span className="text-text-secondary" data-id="element-1586">
                        Revenue impact:
                      </span>
                      <span className="text-accent-error font-mono" data-id="element-1587">
                        {promo.impact}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-2 text-xs font-bold text-accent-success" data-id="element-1588">
                  <span className="w-2 h-2 rounded-full bg-accent-success" data-id="element-1589"></span>{' '}
                  Active
                </div>
              </Card>)}
          </div>
        </div>

        <div data-id="element-1590">
          <h3 className="font-bold text-text-secondary uppercase tracking-wider text-sm mb-4" data-id="element-1591">
            Scheduled (1)
          </h3>
          <Card className="p-4 opacity-75" data-id="element-1592">
            <div className="flex justify-between items-center" data-id="element-1593">
              <div data-id="element-1594">
                <h4 className="font-bold" data-id="element-1595">
                  🎆 New Year Special — Buy 2 Get 1 Free on Pancakes
                </h4>
                <div className="text-sm text-text-secondary mt-1" data-id="element-1596">
                  Period: Dec 31 - Jan 2 · Starts in 16 days
                </div>
              </div>
              <div className="flex gap-2" data-id="element-1597">
                <Button size="sm" variant="secondary" data-id="element-1598">
                  Edit
                </Button>
                <Button size="sm" variant="secondary" data-id="element-1599">
                  Cancel
                </Button>
              </div>
            </div>
          </Card>
        </div>

        <div data-id="element-1600">
          <h3 className="font-bold text-text-secondary uppercase tracking-wider text-sm mb-4" data-id="element-1601">
            Past
          </h3>
          <Card noPadding data-id="element-1602">
            <div className="divide-y divide-white/5" data-id="element-1603">
              <div className="p-4 text-sm text-text-secondary hover:bg-white/5 cursor-pointer" data-id="element-1604">
                ▶ Black Friday — 25% off everything — Nov 29 — 342 orders —
                -156K RSD
              </div>
              <div className="p-4 text-sm text-text-secondary hover:bg-white/5 cursor-pointer" data-id="element-1605">
                ▶ Weekend Warrior — 15% off combos — Nov 23-24 — 89 orders —
                -28K RSD
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}